import { Alert, CircularProgress, Container, Typography } from '@mui/material';
import { useNetsapiensLogin } from 'apis/auth/hook';
import { CacheKeys } from 'utils/cacheKeys';
import { getCookie } from 'utils/helperFunctions';
import { useEffect, useRef } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export default function NetsapiensLoginRedirect() {
  const { cspSlug } = useParams<{ cspSlug: string }>();
  const [searchParams] = useSearchParams();
  const isUnauthorized = searchParams.get('error') === 'unauthorized';
  const isAuthenticated = getCookie(CacheKeys.isAuthenticated) === 'true';
  const hasRequestedLogin = useRef(false);

  const { mutate: loginWithNetsapiens, isPending, isError } = useNetsapiensLogin();

  useEffect(() => {
    if (!cspSlug || isUnauthorized || isAuthenticated || hasRequestedLogin.current) return;

    hasRequestedLogin.current = true;
    loginWithNetsapiens({ csp_name: cspSlug });
  }, [cspSlug, isUnauthorized, isAuthenticated, loginWithNetsapiens]);

  if (isAuthenticated) {
    return <Navigate to='/' replace />;
  }

  if (isUnauthorized || isError) {
    return (
      <Container
        maxWidth='xs'
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Alert severity='error'>
          You are not authorized to access this application. Please contact your administrator.
        </Alert>
      </Container>
    );
  }

  return (
    <Container
      maxWidth='xs'
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography variant='body1' color='text.secondary'>
        {isPending ? 'Redirecting to Netsapiens...' : 'Preparing Netsapiens login...'}
      </Typography>
    </Container>
  );
}
